import React from 'react'
import type { FC } from 'react'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import { CircularProgress } from '@material-ui/core'

import { Card } from '@homeviews/shared-ui'
import { GoToButton, Typography } from '@homeviews/analytics'
import clsx from 'clsx'

const useStyles = makeStyles((theme) =>
  createStyles({
    outerWrapper: {
      position: 'relative',
      paddingBottom: '35px',
      borderColor: 'transparent',
      backgroundColor: theme.colors.grey200,
    },
    circularProgress: {
      position: 'absolute',
      top: 'calc(50% - 30px)',
      left: 'calc(50% - 30px)',
    },
    visibilityHidden: {
      visibility: 'hidden',
    },
    titleWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: '12px',
      color: theme.colors.grey800,
    },
    value: {
      marginBottom: '8px',
      fontSize: '48px',
      fontWeight: 800,
      color: theme.colors.grey800,
    },
  }),
)

type StatisticProps = {
  isLoading: boolean
  title: string
  goToHref: string
  goToIsDisabled: boolean
  goToTrackingEventName?: string
  value?: string | number
  description?: string
}

export const Statistic: FC<StatisticProps> = ({
  isLoading,
  title = 'XXX '.repeat(5),
  goToHref,
  goToIsDisabled,
  goToTrackingEventName = '',
  value = 'X',
  description = 'XXX '.repeat(20),
}) => {
  const classes = useStyles()

  return (
    <Card className={classes.outerWrapper}>
      {isLoading && (
        <CircularProgress size="60px" className={classes.circularProgress} />
      )}
      <div className={clsx(isLoading && classes.visibilityHidden)}>
        <div className={classes.titleWrapper}>
          <Typography variant="body1">{title}</Typography>
          {goToHref && (
            <GoToButton
              href={goToHref}
              trackingEventName={goToTrackingEventName}
              isDisabled={goToIsDisabled}
            />
          )}
        </div>
        <div className={classes.value}>{value}</div>
        <Typography variant="body2">{description}</Typography>
      </div>
    </Card>
  )
}
